import React from "react";
import DashboardLayout from "../dashboard/layout/DashboardLayout";
import { useAuth } from "../../../supabase/auth";
import { Navigate } from "react-router-dom";
import { LoadingScreen } from "../ui/loading-spinner";
import CallRequestsList from "../callRequests/CallRequestsList";

const CallRequestsPage: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingScreen text="Loading..." />;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <DashboardLayout
      activeItem="Call Requests"
      title="Call Requests"
      description="Create and manage your call requests"
    >
      <CallRequestsList />
    </DashboardLayout>
  );
};

export default CallRequestsPage;
